import { Helmet } from "react-helmet";
import Footer from "../footer/Footer";
import Header from "../header/Header";
import HeroGuia from "./guia/HeroGuia";
import GuideBoard from "./guia/GuideBoard";


export default function Guia() {


  return (
    <>
      <Helmet>
        <title>Guia - XDigital Neo</title>‍
        <meta name="description" content="Guía completa de programación - XDneo" />
        <meta property="og:title" content="XDneo - Guía" />
        <meta property="og:description" content="Guía completa de programación - XDneo" />
        <meta property="og:image" content="" />
        <meta property="og:url" content="https://xdigital.com/guia" />
        <meta property="og:site_name" content="XDneo - Guía" />
        <meta property="og:locale" content="es_ES" />
        <meta property="og:type" content="product.group" />
        <link
        rel="stylesheet"
        type="text/css"
        charset="UTF-8"
        href="https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.6.0/slick.min.css"
        />
        <link
        rel="stylesheet"
        type="text/css"
        href="https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.6.0/slick-theme.min.css"
        />
        <meta charSet="utf-8" />
        <title>Guia - XDigital Neo</title>
      </Helmet>
      <Header />
      <HeroGuia />
      <GuideBoard />
      <Footer />
    </>
  )
}